/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import ShopItem from '../components/ShopItem'
import { getEITShops, setFlag, bulkUpdateEnableCompanies } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup
} from "react-bootstrap";
import { TbLayoutGrid, TbLayoutGridAdd } from 'react-icons/tb';
import { FaTimes } from 'react-icons/fa';
import { getCompanies as fetchCompanies } from '../services/companyService';

class EITShop extends Component {
  constructor() {
    super();
    this.state = {
      shops: [],
      totalCount: 0,
      query: this.initQuery,
      itemsPerRow: localStorage.getItem('eitShopItemsPerRow') || '4',
      enableMultiSelect: false,
      selectedShopIds: [],
      showEnableCompanyModal: false,
      companyList: [],
      selectedCompanyIds: [],
      companyLoading: false,
      companyTotalCount: 0,
      companyQuery: {
        currentPage: 1,
        itemsPerPage: 20,
        sortBy: 'created_at',
        sortOrder: -1,
        keyword: '',
        typeFilter: 'all' // all, is_seller, is_factory, is_shipping_agency, is_system
      }
    };
  }

  initQuery = {
    limit: 24,
    itemsPerPage: 24,
    itemOffset: 0,
    currentPage: 1,
    isUpdateQuery: true,
    sortBy: '-total_sales',
    sortOrder: 1,
    totalSoldMin: 0,
    totalSoldMax: 0,
    rating: 0,
    sold30DaysMin: 0,
    sold30DaysMax: 0,
    keyword: ''
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.currentPage)
      return;

    this.setState({ shops: [], isUpdateQuery: false, loadingData: true }, () => {
      this.props.setFlag(CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS, false);
      this.props.getEITShops(this.state.query);
    })
  }

  componentDidMount() {
    document.title = 'EIT Etsy Shop';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    var itemsPerPage = urlParams.get('itemsPerPage');

    if (itemsPerPage) {
      const queryObject = queryString.parse(queryStringFromUrl);

      ['itemsPerPage', 'itemOffset', 'currentPage'].map(key => {
        queryObject[key] = parseInt(queryObject[key])
      })

      queryObject.itemOffset = (queryObject.currentPage - 1) * queryObject.itemsPerPage;
      // Đồng bộ limit với itemsPerPage khi đọc từ URL
      queryObject.limit = queryObject.itemsPerPage;

      this.setState({
        query: queryObject
      }, () => {
        this.props.getEITShops(this.state.query);
      })
    } else {
      var query = JSON.parse(localStorage.getItem('shop_query'));

      if (query) {
        // Chuẩn hoá dữ liệu đọc từ localStorage và gộp với initQuery
        const restored = {
          ...this.initQuery,
          ...query
        };
        // Ép kiểu các trường số quan trọng
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.itemOffset = (restored.currentPage - 1) * restored.itemsPerPage;
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);
        // Đồng bộ limit với itemsPerPage
        restored.limit = restored.itemsPerPage;

        this.setState({
          query: restored
        }, () => {
          this.props.getEITShops(this.state.query);
        })
      }
      else {
        this.setState({
          query: this.initQuery
        }, () => {
          this.props.getEITShops(this.state.query);
        })
      }
    }
  }

  // Toggle select shop
  handleToggleSelectShop = (shopId, checked) => {
    if (!this.state.enableMultiSelect) return;
    this.setState(prev => {
      const set = new Set(prev.selectedShopIds);
      if (checked) set.add(shopId); else set.delete(shopId);
      return { selectedShopIds: Array.from(set) };
    });
  }

  // Toggle enable multi select
  handleToggleEnableMulti = (checked) => {
    this.setState({ enableMultiSelect: checked, selectedShopIds: checked ? this.state.selectedShopIds : [] });
  }

  // Select all / Deselect all
  handleSelectAll = () => {
    if (!this.state.enableMultiSelect) return;
    const allIds = (this.state.shops || []).map(s => s.shop_id);
    this.setState({ selectedShopIds: allIds });
  }

  handleDeselectAll = () => {
    if (!this.state.enableMultiSelect) return;
    this.setState({ selectedShopIds: [] });
  }

  // Load companies into modal
  loadCompaniesForModal = async () => {
    const { companyQuery } = this.state;
    const query = {
      currentPage: companyQuery.currentPage,
      itemsPerPage: companyQuery.itemsPerPage,
      sortBy: companyQuery.sortBy,
      sortOrder: companyQuery.sortOrder,
      keyword: companyQuery.keyword
    };
    if (companyQuery.typeFilter !== 'all') {
      query[companyQuery.typeFilter] = true;
    }
    this.setState({ companyLoading: true });
    try {
      const res = await fetchCompanies(query);
      const data = res?.data?.data;
      this.setState({
        companyList: data?.result || [],
        companyTotalCount: data?.totalCount || 0
      });
    } catch (e) {
      // ignore
    } finally {
      this.setState({ companyLoading: false });
    }
  }

  // Open modal to choose companies
  handleOpenEnableCompany = async () => {
    this.setState({ showEnableCompanyModal: true }, this.loadCompaniesForModal);
  }

  handleToggleCompany = (company_id, checked) => {
    this.setState(prev => {
      const set = new Set(prev.selectedCompanyIds);
      if (checked) set.add(company_id); else set.delete(company_id);
      return { selectedCompanyIds: Array.from(set) };
    });
  }

  handleCompanySearchChange = (e) => {
    this.setState({ companyQuery: { ...this.state.companyQuery, keyword: e.target.value, currentPage: 1 } }, this.loadCompaniesForModal);
  }

  handleCompanyTypeFilterChange = (e) => {
    this.setState({ companyQuery: { ...this.state.companyQuery, typeFilter: e.target.value, currentPage: 1 } }, this.loadCompaniesForModal);
  }

  handleCompanyPageChange = (next) => {
    const totalPages = Math.ceil(this.state.companyTotalCount / this.state.companyQuery.itemsPerPage) || 1;
    const current = this.state.companyQuery.currentPage;
    const newPage = Math.min(Math.max(current + next, 1), totalPages);
    if (newPage === current) return;
    this.setState({ companyQuery: { ...this.state.companyQuery, currentPage: newPage } }, this.loadCompaniesForModal);
  }

  handleCompanySelectAll = () => {
    const ids = this.state.companyList.map(c => c.company_id);
    const set = new Set(this.state.selectedCompanyIds.concat(ids));
    this.setState({ selectedCompanyIds: Array.from(set) });
  }

  handleCompanyDeselectAll = () => {
    const ids = new Set(this.state.companyList.map(c => c.company_id));
    const remaining = this.state.selectedCompanyIds.filter(id => !ids.has(id));
    this.setState({ selectedCompanyIds: remaining });
  }

  handleSaveEnableCompanies = async () => {
    const { selectedShopIds, selectedCompanyIds } = this.state;
    if (selectedShopIds.length === 0) return;
    await this.props.bulkUpdateEnableCompanies(selectedShopIds, selectedCompanyIds);
    this.setState({ showEnableCompanyModal: false, selectedCompanyIds: [] });
    // Optionally refresh list
    this.props.getEITShops(this.state.query);
  }

  componentWillReceiveProps(props) {
    var { shops, totalCount } = props;

    if (totalCount > 0 && totalCount != this.state.totalCount) {
      console.log("ABC")
      this.setState({ shops, totalCount })
    }
  }

  handleChangeTotalSoldMin = (e) => {
    this.setState({
      query: { ...this.state.query, totalSoldMin: e.target.value.trim() }
    })
  }

  handleChangeTotalSoldMax = (e) => {
    this.setState({
      query: { ...this.state.query, totalSoldMax: e.target.value.trim() }
    })
  }

  handleChangeRating = (e) => {
    this.setState({
      query: { ...this.state.query, rating: e.target.value.trim() }
    })
  }

  handleChangeSold30DaysMin = (e) => {
    this.setState({
      query: { ...this.state.query, sold30DaysMin: e.target.value.trim() }
    })
  }

  handleChangeSold30DaysMax = (e) => {
    this.setState({
      query: { ...this.state.query, sold30DaysMax: e.target.value.trim() }
    })
  }

  handleChangeKeyword = (e) => {
    this.setState({
      query: { ...this.state.query, keyword: e.target.value.trim() }
    })
  }

  handleClearKeyword = () => {
    this.setState({
      query: { ...this.state.query, keyword: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSelectSort = (e) => {
    this.setState({
      query: { ...this.state.query, sortBy: e.target.value }
    })
  }

  handleSelectSortOrder = (e) => {
    this.setState({
      query: { ...this.state.query, sortOrder: parseInt(e.target.value) }
    })
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    this.setState({
      query: { ...this.state.query, itemsPerPage, limit: itemsPerPage, itemOffset: 0, currentPage: 1 }
    }, () => {
      this.updateUrl(this.state.query);
      this.props.getEITShops(this.state.query);
      localStorage.setItem('shop_query', JSON.stringify(this.state.query));
    })
  }

  updateUrl = (query) => {
    const { history } = this.props;
    const queryStr = queryString.stringify(query);

    history.push({
      pathname: '/admin/eit/shop',
      search: queryStr,
    });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    console.log('handleSubmit');
    this.updateUrl(this.state.query)
    this.props.getEITShops(this.state.query);
    localStorage.setItem('shop_query', JSON.stringify(this.state.query));
  }

  handleSearch = () => {
    this.updateUrl(this.state.query)
    this.props.getEITShops(this.state.query);
    localStorage.setItem('shop_query', JSON.stringify(this.state.query));
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.currentPage)
      return;

    this.setState({
      query: { ...this.state.query, itemOffset: itemOffset, currentPage: newPage },
      forceUpdateHeyData: false
    }, () => {
      this.setState({ shops: [], isUpdateQuery: false }, () => {
        this.updateUrl(this.state.query)
        this.props.getEITShops(this.state.query);
        localStorage.setItem('shop_query', JSON.stringify(this.state.query));
      })
    })
  }

  handleSetItemsPerRow = (value) => {
    this.setState({ itemsPerRow: value });
    localStorage.setItem('eitShopItemsPerRow', value);
  }

  renderSearchFilter = () => {

    return <>
      <Row className="">
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_SEARCH)}</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.keyword}
              onChange={this.handleChangeKeyword}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm shop..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.keyword && (
              <InputGroup.Text
                onClick={this.handleClearKeyword}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_SALES)} ≥</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.totalSoldMin}
              onChange={this.handleChangeTotalSoldMin}
              placeholder={getTranslate(LANGUAGE_KEYS.TEXT_MIN)}
              aria-label="daily_view"
              aria-describedby="basic-addon1"
            />
          </InputGroup>
        </Col>

        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_SALES)} ≤</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.totalSoldMax}
              onChange={this.handleChangeTotalSoldMax}
              placeholder={getTranslate(LANGUAGE_KEYS.TEXT_MAX)}
              aria-label="daily_view"
              aria-describedby="basic-addon1"
            />
          </InputGroup>
        </Col>

        <Col md="3">
          <InputGroup>
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP_SOLD_30_DAYS)} ≥</InputGroup.Text>
            <Form.Control
              value={this.state.query.sold30DaysMin}
              onChange={this.handleChangeSold30DaysMin}
              placeholder={getTranslate(LANGUAGE_KEYS.TEXT_MIN)}
              aria-label="price-min"
              aria-describedby="basic-addon1"
            />
          </InputGroup>
        </Col>

      </Row>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup>
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP_SOLD_30_DAYS)} ≤</InputGroup.Text>
            <Form.Control
              value={this.state.query.sold30DaysMax}
              onChange={this.handleChangeSold30DaysMax}
              placeholder={getTranslate(LANGUAGE_KEYS.TEXT_MAX)}
              aria-label="price-min"
              aria-describedby="basic-addon1"
            />
          </InputGroup>
        </Col>

        <Col md="3">
          <InputGroup>
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_RATING)} ≥</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.rating}
              onChange={this.handleChangeRating}
              placeholder={getTranslate(LANGUAGE_KEYS.TEXT_RATING)}
              aria-label="daily_view"
              aria-describedby="basic-addon1"
            />
          </InputGroup>
        </Col>

        <Col md="3">
          <InputGroup>
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_SORT_BY)}</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="-total_sales">{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_SALES)}</option>
              <option value="-sale_30_days">{getTranslate(LANGUAGE_KEYS.TEXT_SHOP_SOLD_30_DAYS)}</option>
              <option value="-revenue_30_days_calculate">{getTranslate(LANGUAGE_KEYS.TEXT_REVENUE_30_DAYS)}</option>
              <option value="-sale_per_views">{getTranslate(LANGUAGE_KEYS.TEXT_SALE_RATIO)}</option>
              <option value="-rating_value">{getTranslate(LANGUAGE_KEYS.TEXT_RATING)}</option>
              <option value="-total_listings">{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_LISTINGS)}</option>
              <option value="-opening_date">{getTranslate(LANGUAGE_KEYS.TEXT_OPENING_DATE)}</option>
              <option value="-created_at">{getTranslate(LANGUAGE_KEYS.TEXT_CREATED_DATE_EIT)}</option>
              <option value="-updated_at">{getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_AT)}</option>
            </Form.Select>
          </InputGroup>
        </Col>

        <Col md="2">
          <InputGroup className="">
            <InputGroup.Text>{getTranslate(LANGUAGE_KEYS.TEXT_SORT_ORDER)}</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="1">{getTranslate(LANGUAGE_KEYS.TEXT_DECREASE)}</option>
              <option value="-1">{getTranslate(LANGUAGE_KEYS.TEXT_INCREASE)}</option>
            </Form.Select>
          </InputGroup>
        </Col>

        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            {getTranslate(LANGUAGE_KEYS.TEXT_SEARCH)}
          </Button>
        </Col>
      </Row>
    </>
  }

  render() {
    return (
      <>
        <Container fluid>
          {/* Bulk actions bar: chỉ hiển thị khi đã bật multiple select */}
          {this.state.enableMultiSelect && (
            <Row className="mb-2 align-items-center">
              <Col md="6" className="d-flex align-items-center gap-3">
                <Button variant="light" size="sm" onClick={this.handleSelectAll}>Select All</Button>
                <Button variant="light" size="sm" onClick={this.handleDeselectAll}>Deselect All</Button>
              </Col>
              <Col md="6" className="text-end">
                {this.state.selectedShopIds.length > 0 && (
                  <div className="d-inline-flex align-items-center gap-2">
                    <span>Đã chọn: <b>{this.state.selectedShopIds.length}</b> shop</span>
                    <Button variant="outline-success" size="sm" onClick={this.handleOpenEnableCompany}>
                      Chọn enable company
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          )}
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                EIT Shop Etsy
              </h2>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>{getTranslate(LANGUAGE_KEYS.TEXT_FOUND_X_SHOPS, [<span className='text-danger'>{this.state.totalCount}</span>])}:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <div className="d-inline-block me-3 align-middle">
                  <Form.Check
                    type="checkbox"
                    id="enable-multi-select"
                    label="Enable multiple select"
                    checked={this.state.enableMultiSelect}
                    onChange={(e) => this.handleToggleEnableMulti(e.target.checked)}
                  />
                </div>
                <span className="me-2">Hiển thị:</span>
                <Button
                  variant={this.state.itemsPerRow === '4' ? 'primary' : 'outline-primary'}
                  size="sm"
                  className="me-1"
                  style={{ borderRadius: '6px' }}
                  onClick={() => this.handleSetItemsPerRow('4')}
                  title="Lưới to (4 shop/dòng)"
                >
                  <TbLayoutGrid size={20} />
                </Button>
                <Button
                  variant={this.state.itemsPerRow === '6' ? 'primary' : 'outline-primary'}
                  size="sm"
                  style={{ borderRadius: '6px' }}
                  onClick={() => this.handleSetItemsPerRow('6')}
                  title="Lưới nhỏ (6 shop/dòng)"
                >
                  <TbLayoutGridAdd size={20} />
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số shop/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={24}>24</option>
                    <option value={36}>36</option>
                    <option value={48}>48</option>
                    <option value={72}>72</option>
                    <option value={96}>96</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            {this.state.shops
              .map(shop => <Col key={shop.shop_id} md={this.state.itemsPerRow === '4' ? '3' : '2'}>
                <div className="">
                  {this.state.enableMultiSelect && (
                    <div className="eitshop-cbox">
                      <Form.Check
                        type="checkbox"
                        checked={this.state.selectedShopIds.includes(shop.shop_id)}
                        onChange={(e) => this.handleToggleSelectShop(shop.shop_id, e.target.checked)}
                      />
                    </div>
                  )}
                  <ShopItem shop={shop} />
                </div>
              </Col>)}
          </Row>
        </Container>
        {/* Enable company modal */}
        {this.state.showEnableCompanyModal && (
          <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Chọn enable company</h5>
                  <button type="button" className="btn-close" onClick={() => this.setState({ showEnableCompanyModal: false })} />
                </div>
                <div className="modal-body">
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Select value={this.state.companyQuery.typeFilter} onChange={this.handleCompanyTypeFilterChange}>
                        <option value="all">Tất cả loại</option>
                        <option value="is_seller">Seller</option>
                        <option value="is_factory">Factory</option>
                        <option value="is_shipping_agency">Shipping Agency</option>
                        <option value="is_system">System</option>
                      </Form.Select>
                    </Col>
                    <Col md={8}>
                      <InputGroup>
                        <Form.Control placeholder="Tìm kiếm công ty..." value={this.state.companyQuery.keyword} onChange={this.handleCompanySearchChange} />
                      </InputGroup>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <Button size="sm" variant="light" className="me-2" onClick={this.handleCompanySelectAll}>Select All</Button>
                      <Button size="sm" variant="light" onClick={this.handleCompanyDeselectAll}>Deselect All</Button>
                    </div>
                    <div>
                      <span className="text-muted small">Đã chọn: {this.state.selectedCompanyIds.length}</span>
                    </div>
                  </div>

                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th style={{ width: '40px' }}></th>
                        <th>ID</th>
                        <th>Tên</th>
                        <th>Mã</th>
                        <th>Mô tả</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.companyLoading ? (
                        <tr><td colSpan={5} className="text-center">Đang tải...</td></tr>
                      ) : (
                        this.state.companyList.map(c => (
                          <tr key={c.company_id}>
                            <td>
                              <Form.Check
                                type="checkbox"
                                checked={this.state.selectedCompanyIds.includes(c.company_id)}
                                onChange={(e) => this.handleToggleCompany(c.company_id, e.target.checked)}
                              />
                            </td>
                            <td className="fw-bold">{c.company_id}</td>
                            <td>
                              <div className="fw-bold">{c.name || '-'}</div>
                              {c.legal_name && (<small className="text-muted d-block">{c.legal_name}</small>)}
                            </td>
                            <td>{c.company_shortcode}</td>
                            <td style={{ maxWidth: '300px' }}>
                              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={c.description}>{c.description || '-'}</div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>

                  {/* Pagination */}
                  {Math.ceil(this.state.companyTotalCount / this.state.companyQuery.itemsPerPage) > 1 && (
                    <div className="d-flex justify-content-center mt-2">
                      <Button size="sm" className="me-2" variant="outline-primary" disabled={this.state.companyQuery.currentPage === 1} onClick={() => this.handleCompanyPageChange(-1)}>Trước</Button>
                      <span className="mx-2 my-auto small">Trang {this.state.companyQuery.currentPage} / {Math.ceil(this.state.companyTotalCount / this.state.companyQuery.itemsPerPage)}</span>
                      <Button size="sm" className="ms-2" variant="outline-primary" disabled={this.state.companyQuery.currentPage >= Math.ceil(this.state.companyTotalCount / this.state.companyQuery.itemsPerPage)} onClick={() => this.handleCompanyPageChange(1)}>Sau</Button>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={() => this.setState({ showEnableCompanyModal: false })}>Đóng</Button>
                  <Button variant="primary" onClick={this.handleSaveEnableCompanies}>Lưu</Button>
                </div>
              </div>
            </div>
          </div>
        )}
        <Pagination totalItems={this.state.totalCount} itemsPerPage={this.state.query.itemsPerPage} itemOffset={this.state.query.itemOffset} updatePage={this.updatePage} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    shops: state.eitShopReducer.shops,
    totalCount: state.eitShopReducer.totalCount
    // finishGetShops: state.miscReducer.flag[CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS]
  };
};

export default connect(mapStateToProps, { getEITShops: getEITShops, setFlag, bulkUpdateEnableCompanies })(EITShop);